import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import { NEXT_GLYPH } from '../../const/Glyphicons';
import textTranslates from './translate.json';

const NextButton = (props) => {
    return(
        <Button
            disabled={props.isButtonDisabled}
            floated="right"
            glyph={NEXT_GLYPH}
            id="nextBtn"
            label={textTranslates.nextWindowBtnLabel}
            onClick={props.onNextButtonClick}/>
    );
};

NextButton.propTypes = {
    isButtonDisabled: PropTypes.bool,
    onNextButtonClick: PropTypes.func
};

export default NextButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/NextButton.js